<form [formGroup]="mobileFolioForm">
  <h5 class="text-primary">Mobile folio</h5>
  <button type="button"
          class="btn btn-outline-primary border-0 float-end"
          (click)="toggleEditMode()">
    @if (!editMode) {
      <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
    } @else {
      <fa-icon [icon]="['far', 'save']"></fa-icon>
    }
  </button>
  <br />

  <!-- Invoices -->
  <b class="mt-3">Mobile folio - Invoice</b>
  <era-mobilefolioforminvoice-ui [group]="mobileFolioForm"
                                 arrayName="invoice"
                                 [invoice]="invoice"
                                 [reservation]="reservation()"
                                 [data]="$safeNavigationMigration(mobileFolio()?.Invoice)"
                                 [editMode]="editMode"></era-mobilefolioforminvoice-ui>

  <!-- Proformas -->
  <b class="mt-3">Mobile folio - Proforma</b>
  <era-mobilefolioforminvoice-ui [group]="mobileFolioForm"
                                 arrayName="proforma"
                                 [invoice]="proforma"
                                 [reservation]="reservation()"
                                 [data]="$safeNavigationMigration(mobileFolio()?.Proforma)"
                                 [editMode]="editMode"></era-mobilefolioforminvoice-ui>
</form>